/* Dummy module */
import noop from "lodash/noop";
module.exports = noop;
